/* Copyright (c) 2018 Scaper */

import { UserInfo } from "@firebase/auth-types";
import * as React from "react";
import { connect } from "react-redux";
import { IApi } from "../../api/api";
import { IAppState } from "../appState";
import { SignIn } from "./signIn";

interface IOwnProps {
    api: IApi;
    children: (userInfo: UserInfo) => JSX.Element;
    className?: string;
}

interface IStateProps {
    userInfo: UserInfo | false | undefined;
}

type IProps = IOwnProps & IStateProps;

class UnconnectedRequireSignedInOrPrompt extends React.PureComponent<IProps, {}> {
    public render() {
        const { api, children, className, userInfo } = this.props;

        if (userInfo == null) {
            return <div className={className}>// TODO: LOADING</div>;
        }

        if (userInfo === false) {
            return <SignIn api={api} />;
        }

        return children(userInfo);
    }
}

function mapStateToProps(state: IAppState): IStateProps {
    const { user } = state;
    const { userInfo } = user;
    return { userInfo };
}

export const RequireSignedInOrPrompt = connect<IStateProps, {}, IOwnProps, IAppState>(mapStateToProps)(UnconnectedRequireSignedInOrPrompt);
